// Class: motion.easing._Expo.ExpoEaseOut

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var ExpoEaseOut = function() {
}

// Meta

ExpoEaseOut.__name__ = ["motion","easing","_Expo","ExpoEaseOut"];
ExpoEaseOut.__isInterface__ = false;
ExpoEaseOut.__interfaces__ = [(motion_easing_IEasing().default)];
ExpoEaseOut.prototype = {
	calculate: function(k) {
		if(k == 1) {
			return 1;
		} else {
			return 1 - Math.exp(-6.931471805599453 * k);
		}
	},
	ease: function(t,b,c,d) {
		if(t == d) {
			return b + c;
		} else {
			return c * (1 - Math.exp(-6.931471805599453 * t / d)) + b;
		}
	}
};
ExpoEaseOut.prototype.__class__ = ExpoEaseOut.prototype.constructor = $hxClasses["motion.easing._Expo.ExpoEaseOut"] = ExpoEaseOut;

// Init



// Statics




// Export

exports.default = ExpoEaseOut;